import React from "react";

export const Title = props => {
	const { className, children, type } = props;
	const Tag = type || "h1";

	return <Tag className={`${className ? className : ""} -title`}>{children}</Tag>;
};


// WEBPACK FOOTER //
// src/atoms/lib/Title.js